import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

export type SocietySharesLedgerRange = {
  from: number;
  to: number;
  encumbrances?: unknown[];
};

export type SocietySharesLedgerResponse = Record<
  string,
  SocietySharesLedgerRange[]
>;

type GetSocietySharesLedgerProps = {
  societyId: string;
  holdingClassId: string;
};

export const getSocietySharesLedger = async ({
  societyId,
  holdingClassId,
}: GetSocietySharesLedgerProps): Promise<SocietySharesLedgerResponse> => {
  const { data } = await axiosV2.get('/shares/ledger', {
    params: { societyId, holdingClassId },
  });

  const decodedData: any = await decryptResponse(data);

  return (decodedData || {}) as SocietySharesLedgerResponse;
};
